"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Page error:", error);
  }, [error]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-purple-50/30 to-blue-50/30 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(82,49,231,0.02)_1.6px,transparent_1.6px),linear-gradient(to_right,rgba(82,49,231,0.02)_1.6px,transparent_1.6px)] bg-[size:24px_24px]" />
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 pt-40 md:pt-44 lg:pt-48 pb-20">
        <div className="text-center max-w-2xl mx-auto">
          <div className="w-20 h-20 mx-auto mb-8 rounded-full bg-[#5231E7]/10 flex items-center justify-center">
            <svg
              className="w-10 h-10 text-[#5231E7]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
              />
            </svg>
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Something went{" "}
            <span className="bg-gradient-to-r from-[#5231E7] to-[#764AF1] bg-clip-text text-transparent">
              wrong
            </span>
          </h1>

          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            We hit a temporary snag loading this page. A quick refresh usually
            fixes it — give it another try.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={reset}
              className="shadow-none rounded-full cursor-pointer px-6 py-2 font-medium text-base"
            >
              Try Again
            </Button>

            <Link href="/">
              <Button
                variant="outline"
                className="shadow-none rounded-full cursor-pointer px-6 py-2 font-medium text-base"
              >
                Go Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
